var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c("vs-col", { attrs: { "vs-w": "12" } }, [
        _c("h3", [_vm._v(" Mantenedor de estados para kanban ")]),
        _c("div", { staticClass: "margin-top" }, [
          _c("br"),
          _vm._v("Estas opciones activas aparecerán en las cards del kanban ")
        ]),
        _vm.categoryStates && !_vm.categoryStates.length
          ? _c("div", [
              _c("h5", { staticClass: "info-documents" }, [
                _vm._v(" Pulsa el botón "),
                _c(
                  "span",
                  { staticStyle: { padding: "0 4px" } },
                  [
                    _c("vs-button", {
                      staticClass: "margin-right",
                      attrs: {
                        color: "primary",
                        size: "small",
                        disabled: "",
                        type: "border",
                        icon: "search"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" para ver las categorías del estado ")
              ])
            ])
          : _vm._e()
      ]),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "12", id: "listado-opciones" } },
        [
          _c(
            "vs-row",
            {
              attrs: {
                "vs-type": "flex",
                "vs-align": "space-around",
                "vs-justify": "space-around"
              }
            },
            [
              _c(
                "vs-col",
                {
                  staticClass: "margin-top",
                  attrs: { "vs-sm": "12", "vs-lg": "6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-new" },
                    [
                      _c("h4", [_vm._v("Estados")]),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED028" } },
                        [
                          _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Agregar Estado",
                                expression: "'Agregar Estado'"
                              }
                            ],
                            staticClass: "margin-right",
                            attrs: {
                              color: "primary",
                              type: "border",
                              icon: "playlist_add"
                            },
                            on: {
                              click: function($event) {
                                return _vm.createOption()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-list",
                    { staticClass: "bg-white margin-top box-options" },
                    _vm._l(_vm.categoryStates, function(category) {
                      return _c(
                        "div",
                        {
                          key: category.opcionId,
                          staticClass: "wrap-list-item"
                        },
                        [
                          _c("ListItemOptionState", {
                            attrs: {
                              option: category,
                              type: "category",
                              selectedCategory:
                                _vm.selectedState &&
                                _vm.selectedState.opcionId === category.opcionId
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                {
                  staticClass: "margin-top",
                  attrs: { "vs-sm": "12", "vs-lg": "6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-new" },
                    [
                      _c("h4", [_vm._v("Sub-Estados")]),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED031" } },
                        [
                          _vm.selectedState.opcionId
                            ? _c("vs-button", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Agregar categoría a estado",
                                    expression: "'Agregar categoría a estado'"
                                  }
                                ],
                                staticClass: "margin-right",
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  icon: "playlist_add",
                                  "data-cy": "add-category"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.createOption(_vm.selectedState)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.subStateStates && _vm.subStateStates.length
                    ? _c(
                        "vs-list",
                        { staticClass: "bg-white margin-top box-options" },
                        _vm._l(_vm.subStateStates, function(subState) {
                          return _c(
                            "div",
                            {
                              key: subState.opcionId,
                              staticClass: "wrap-list-item"
                            },
                            [
                              _c("ListItemOptionState", {
                                attrs: {
                                  option: subState,
                                  type: "document",
                                  subStates: _vm.selectedState
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.createDocument ? "Nuevo SubEstado" : "Nuevo Estado",
            "hide-footer": "",
            centered: ""
          },
          model: {
            value: _vm.createMood,
            callback: function($$v) {
              _vm.createMood = $$v
            },
            expression: "createMood"
          }
        },
        [
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.option.valor,
                  expression: "option.valor"
                }
              ],
              staticClass: "input-option input-edit",
              attrs: {
                maxlength: "10",
                placeholder: "Abreviación",
                size: "small"
              },
              domProps: { value: _vm.option.valor },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.option, "valor", $event.target.value)
                }
              }
            })
          ]),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.option.descripcion,
                  expression: "option.descripcion"
                }
              ],
              staticClass: "input-option input-edit",
              attrs: {
                maxlength: "100",
                placeholder: "Nombre de opción",
                size: "small"
              },
              domProps: { value: _vm.option.descripcion },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.option, "descripcion", $event.target.value)
                }
              }
            })
          ]),
          _c(
            "div",
            { staticClass: "box-button" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "margin-top",
                  attrs: { color: "primary", type: "border", icon: "save" },
                  on: {
                    click: function($event) {
                      return _vm.saveOption()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }